const CART_STORAGE_KEY = 'old_book_cart';

const loadCartFromStorage = () => {
  try {
    const raw = localStorage.getItem(CART_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    }
  } catch (e) {
    console.error('Error loading cart from storage', e);
  }
  return [];
};

const saveCartToStorage = (items) => {
  try {
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
  } catch (e) {
    console.error('Error saving cart to storage', e);
  }
};

export default {
  namespaced: true,
  state: () => ({
    items: loadCartFromStorage(),
    isDrawerOpen: false
  }),
  getters: {
    cartItems: (state) => state.items,
    totalItems: (state) => state.items.length,
    totalPrice: (state) => {
      return state.items.reduce((sum, item) => sum + (Number(item.price) || 0), 0);
    },
    totalWeight: (state) => {
      return state.items.reduce((sum, item) => sum + (Number(item.weight) || 0), 0);
    },
    isDrawerOpen: (state) => state.isDrawerOpen,
    groupedByBooth: (state) => {
      const groups = {};
      state.items.forEach((item) => {
        const key = item.boothId || 'unknown';
        if (!groups[key]) {
          groups[key] = {
            boothId: item.boothId,
            boothName: item.boothName || 'Gian hàng sách',
            sellerId: item.sellerId,
            sellerName: item.sellerName || 'Người bán',
            saleType: item.saleType,
            items: []
          };
        }
        groups[key].items.push(item);
      });
      return Object.values(groups);
    }
  },
  mutations: {
    ADD_TO_CART(state, item) {
      if (!item || !item.id) return;
      
      if (item.type === 'COMBO' || item.type === 'BOOTH') {
        // When adding whole Combo/Booth, remove all existing single book items of this booth to avoid duplication
        state.items = state.items.filter((i) => i.boothId !== item.boothId);
        state.items.unshift(item);
      } else {
        // When adding a single book, remove whole Combo/Booth of this booth if present
        state.items = state.items.filter((i) => !(i.boothId === item.boothId && (i.type === 'COMBO' || i.type === 'BOOTH')));
        const existingIndex = state.items.findIndex((i) => i.id === item.id);
        if (existingIndex === -1) {
          state.items.unshift(item);
        }
      }
      saveCartToStorage(state.items);
    },
    ADD_MULTIPLE_TO_CART(state, items) {
      if (!Array.isArray(items) || items.length === 0) return;
      
      items.forEach((item) => {
        if (!item || !item.id) return;
        if (item.type === 'COMBO' || item.type === 'BOOTH') {
          state.items = state.items.filter((i) => i.boothId !== item.boothId);
          state.items.unshift(item);
        } else {
          state.items = state.items.filter((i) => !(i.boothId === item.boothId && (i.type === 'COMBO' || i.type === 'BOOTH')));
          const existingIndex = state.items.findIndex((i) => i.id === item.id);
          if (existingIndex === -1) {
            state.items.unshift(item);
          }
        }
      });
      saveCartToStorage(state.items);
    },
    REMOVE_FROM_CART(state, itemId) {
      state.items = state.items.filter((i) => i.id !== itemId);
      saveCartToStorage(state.items);
    },
    CLEAR_CART(state) {
      state.items = [];
      saveCartToStorage(state.items);
    },
    SET_DRAWER_OPEN(state, isOpen) {
      state.isDrawerOpen = !!isOpen;
    }
  },
  actions: {
    addToCart({ commit }, { item, openDrawer = true }) {
      commit('ADD_TO_CART', item);
      if (openDrawer) {
        commit('SET_DRAWER_OPEN', true);
      }
      return true;
    },
    addMultipleToCart({ commit }, { items, openDrawer = true }) {
      if (!Array.isArray(items) || items.length === 0) return 0;
      commit('ADD_MULTIPLE_TO_CART', items);
      if (openDrawer) {
        commit('SET_DRAWER_OPEN', true);
      }
      return items.length;
    },
    removeFromCart({ commit }, itemId) {
      commit('REMOVE_FROM_CART', itemId);
    },
    clearCart({ commit }) {
      commit('CLEAR_CART');
    },
    openDrawer({ commit }) {
      commit('SET_DRAWER_OPEN', true);
    },
    closeDrawer({ commit }) {
      commit('SET_DRAWER_OPEN', false);
    },
    toggleDrawer({ commit, state }) {
      commit('SET_DRAWER_OPEN', !state.isDrawerOpen);
    }
  }
};
